import { createContext, useContext, useEffect, useState } from "react";

const DeviceContext = createContext(null);
const STORAGE_KEY = "hscis_preview_mode";

// preview_mode: "mobile" | "desktop" | "auto"
export const DeviceProvider = ({ children }) => {
  const [previewMode, setPreviewMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "auto";
    } catch {
      return "auto";
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, previewMode);
  }, [previewMode]);

  const isMobileDevice =
    typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

  const effectiveMode =
    previewMode === "auto" ? (isMobileDevice ? "mobile" : "desktop") : previewMode;

  return (
    <DeviceContext.Provider value={{ previewMode, setPreviewMode, effectiveMode }}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = () => {
  const ctx = useContext(DeviceContext);
  if (!ctx) throw new Error("useDevice must be used inside DeviceProvider");
  return ctx;
};
